/** Data URL for plain Text annotations on the canvas (roundel with “T”). */
export const TEXT_ANNOTATION_MARKER_IMAGE_DATA_URL =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">' +
      '<rect width="28" height="28" rx="6" fill="#ff4d4f"/>' +
      '<text x="14" y="19.5" text-anchor="middle" font-family="system-ui,-apple-system,BlinkMacSystemFont,sans-serif" font-size="15" font-weight="700" fill="#fff">T</text>' +
      '</svg>'
  );

/** Html img size for Text billboard pins (matches visual weight of default 24px pins). */
export const TEXT_ANNOTATION_MARKER_IMG_PX = 28;
